const invoiceDueFormatted = {
  width: 0,
  id: 'formattedDueDate',
  accessor: row => row.formattedDueDate,
  resizable: false,
  Cell: () => null
};

export default invoiceDueFormatted;
